import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { NotificationProvider } from './components/shared/NotificationContext';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b4d0f21bcbf36c0cb2437fccfd604f3d@o4509656627544064.ingest.us.sentry.io/4509656649760768",
  sendDefaultPii: true
});

// ✅ Aplică tema ÎNAINTE de primul render — elimină flash-ul negru
const savedTheme = localStorage.getItem("theme") || "dark";
document.body.setAttribute("data-theme", savedTheme);
document.documentElement.setAttribute("data-theme", savedTheme);
document.body.style.background = savedTheme === "light" ? "#F2F4FB" : "#07070C";
document.documentElement.style.background = savedTheme === "light" ? "#F2F4FB" : "#07070C";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <NotificationProvider>
    <Router>
      <App />
    </Router>
  </NotificationProvider>
);